import Highcharts from 'highcharts';

export function initialize(/* application */) {
  Highcharts.setOptions({
    lang: {
      thousandsSep: ',',
    },
    title: {
      style: {
        fontWeight: '400'
      }
    },
    xAxis: {
      lineColor: '#c9c9c9'
    },
    plotOptions: {
      pie: {
        borderRadius: 0
      },
      column: {
        borderRadius: 0
      },
      bar: {
        borderRadius: 0
      },
    }
  });
}

export default {
  initialize,
};
